import React, { Component } from 'react';
import Token from './Token';

export default class Interests extends Component {
	remove = () => {
		this.props.edit(null);
	};

	edit = () => {
		this.props.editLine(this.props.edit, 'interests', this.props.token);
	};

	render() {
		return <div>{Object.keys(this.props.token).map(key => {
			return <Token key={key}
				edit={this.edit}
				remove={this.remove}
				value={`${key} interests ${JSON.stringify(this.props.token[key])}`} />;
		})}</div>;
	}
}
